import { Shield, Lock, Eye, FileText } from 'lucide-react';

export function Privacy() {
    return (
        <div className="max-w-4xl mx-auto px-6 py-12 animate-in fade-in duration-500">
            <div className="text-center mb-16">
                <div className="w-16 h-16 bg-brand-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
                    <Shield className="w-8 h-8 text-brand-primary" />
                </div>
                <h1 className="text-4xl font-bold text-white mb-4">Privacy Policy</h1>
                <p className="text-slate-400">Last Updated: February 2026</p>
            </div>

            <div className="space-y-12">
                <section className="bg-slate-900/50 p-8 rounded-3xl border border-slate-800">
                    <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                        <Lock className="w-6 h-6 text-brand-primary" />
                        Anonymous & Secure
                    </h2>
                    <p className="text-slate-300 leading-relaxed mb-4">
                        EMI operates on a strict "Privacy First" architecture. We use anonymous authentication to key your data to your device session without requiring personal identifiers like email, phone number, or name.
                    </p>
                    <p className="text-slate-300 leading-relaxed">
                        Your documents are stored in a private, encrypted cloud storage bucket (`emi-project-9e4a4`). Only the session key generated on your device has access to write to your personal library path.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-3">
                        <Eye className="w-5 h-5 text-slate-400" />
                        Data Usage
                    </h2>
                    <ul className="space-y-4 text-slate-300">
                        <li className="flex gap-3">
                            <span className="w-1.5 h-1.5 bg-brand-primary rounded-full mt-2.5 flex-shrink-0" />
                            <span>We do not scan, read, or analyze the content of your PDF files.</span>
                        </li>
                        <li className="flex gap-3">
                            <span className="w-1.5 h-1.5 bg-brand-primary rounded-full mt-2.5 flex-shrink-0" />
                            <span>Files are retained according to your account activity. Inactive anonymous libraries may be purged after 90 days.</span>
                        </li>
                        <li className="flex gap-3">
                            <span className="w-1.5 h-1.5 bg-brand-primary rounded-full mt-2.5 flex-shrink-0" />
                            <span>We use basic analytics (Google Analytics) to understand site traffic, but this is not linked to your document contents.</span>
                        </li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-3">
                        <FileText className="w-5 h-5 text-slate-400" />
                        Terms of Service
                    </h2>
                    <p className="text-slate-300 leading-relaxed">
                        By using the EMI Universal Reader, you agree not to upload illegal, prohibited, or malicious content. We reserve the right to remove content that violates international digital safety standards.
                    </p>
                </section>
            </div>
        </div>
    );
}
